import { BaseOauthClient } from "./base";

export class GoogleSheetsOauthClient extends BaseOauthClient {
  provider = "google_sheets";
  baseUrl = "https://accounts.google.com";
  authorizationEndpoint = '/o/oauth2/v2/auth';
  tokenEndpoint = "https://oauth2.googleapis.com/token";

  clientId = process.env.GOOGLE_CLIENT_ID || "";
  clientSecret = process.env.GOOGLE_CLIENT_SECRET || "";

  scopes = ["https://www.googleapis.com/auth/spreadsheets.readonly"];
  extraParams = {
    access_type: "offline",
    prompt: "consent",
  };

  constructor(team: string, supabaseClient: any, id?: string) {
    super(team, supabaseClient, id);
    this.initializeOauthClient();

    this.actions = {
      "getSheets": async (params: any) => {
        let data = await this.fetcher.fetch("https://sheets.googleapis.com/v4/spreadsheets/" + params.docId).then(a => a.json());
        let sheets = data.sheets.map((a: any) => ({
          value: a.properties.title,
          label: a.properties.title,
        }));
        return sheets as { label: string, value: string }[];
      }
    }
  }

  async getRecords(docId: string, sheetName: string) {
    const url = `https://docs.google.com/spreadsheets/d/${docId}/gviz/tq?tqx=out:csv&sheet=${sheetName}`;
    // const url = `https://docs.google.com/feeds/download/spreadsheets/Export?key=${docId}&exportFormat=csv&gid=0`;
    let response = await this.fetcher.fetch(url);
    return response;
  }
}